<template>
  <v-dialog
    v-model="isOpenDialog"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="fixed-bar" dark flat color="primary">
        <v-btn icon dark @click="closeDialog()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <div class="search-panel pa-2 grey lighten-3" style="max-height: 56px">
        <v-text-field
          color="red"
          label="search product"
          prepend-inner-icon="mdi-magnify"
          solo
          flat
          outlined
          dense
          clearable
          v-model="params.search"
          @input="searchSkus"
        >
        </v-text-field>
      </div>

      <v-skeleton-loader
        class="pt-16"
        v-if="!isLoaded"
        type="list-item-two-line, divider, list-item-two-line, divider,list-item-two-line,divider,list-item-two-line,divider"
      ></v-skeleton-loader>

      <v-container
        class="pt-16 mt-16"
        v-if="products.length == 0 && isLoaded && !isLoading"
      >
        <div align="center">
          <v-img src="../../assets/inbox.png" width="128px"></v-img>
          <h5 class="pt-3 subtitle-2 grey--text text--darken-2">
            Sorry, No data found
          </h5>
        </div>
      </v-container>

      <v-container
        v-on:scroll.capture="bottomVisible()"
        id="scroll-target"
        class="pt-16 mt-1 sku-container"
      >
        <v-row
          v-for="item in products"
          :key="item.id"
          v-ripple
          @click="handleOpenDialog(item.id)"
        >
          <v-col cols="4">
            <v-avatar color="dark" size="96" rounded>
              <v-img :src="item.image" alt=""></v-img>
            </v-avatar>
          </v-col>
          <v-col cols="8 text-left">
            <h5 class="subtitle-1">{{ item.sku_name }}</h5>

            <h5 class="caption grey--text text--darken-2">
              {{ item.product.product }} - {{ item.product.name }}
            </h5>
            <h5 class="caption grey--text text--darken-4">
              Color : {{ item.colour.colour }} | Size : {{ item.size.size }}
            </h5>
            <h5 class="subtitle-2 primary--text">₹ {{ item.mrp }}</h5>
          </v-col>
        </v-row>
      </v-container>
      <div v-if="isLoading" class="text-center pt-2 pb-2">
        <v-progress-circular
          :width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-card>
    <Product :dialog.sync="productDialog" :id="current_product" />

    <v-snackbar v-model="snackbar" color="error" timeout="1500"
      >{{ snackbar_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>
<script>
import Product from "./_product";
export default {
  components: {
    Product,
  },
  data() {
    return {
      snackbar: false,
      snackbar_message: "Internal Server Error",
      title: this.$route.params.name,
      isOpenDialog: false,
      productDialog: false,
      products: [],
      isLoaded: false,
      isLoading: false,
      isBottom: false,
      total_count: 0,
      params: {
        search: "",
        page_size: 10,
        database_offset: 0,
        product_id: 0,
      },
      current_product: null,
    };
  },
  created() {
    document.documentElement.style.overflow = "hidden";
    this.isOpenDialog = true;
    this.isLoaded = false;
    this.products = [];
    this.params.product_id = this.$route.params.id;
    this.fetchSkus();
  },
  watch: {
    isBottom(isBottom) {
      if (
        isBottom &&
        this.params.database_offset + this.params.page_size < this.total_count
      ) {
        this.isLoading = true;
        this.params.database_offset += this.params.page_size;
        this.fetchSkus();
      }
    },
  },

  methods: {
    bottomVisible() {
      const scrollY = document.getElementById("scroll-target").scrollTop;
      const visible = document.getElementById("scroll-target").clientHeight;
      const pageHeight = document.getElementById("scroll-target").scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      this.isBottom = bottomOfPage || pageHeight < visible;
    },
    fetchSkus() {
      this.$api.getProductSkus(this.params).then(
        (response) => {
          if (response.data.status == "success") {
            this.products.push(...response.data.skus);
            this.total_count = response.data.count;
            this.isLoading = false;
            this.isLoaded = true;
          }
        },
        (error) => {
          console.log(error);
          this.isLoaded = true;
          this.isLoading = false;
          this.snackbar = true;
        }
      );
    },
    searchSkus() {
      if (!this.isLoaded) return;
      if (
        this.params.search === "" ||
        this.params.search === null ||
        (this.params.search !== null && this.params.search.length > 2)
      ) {
        this.isLoaded = false;
        this.products = [];
        this.params.page_size = 10;
        this.params.database_offset = 0;
        this.fetchSkus();
      }
    },
    handleOpenDialog(product) {
      this.current_product = product;
      this.productDialog = true;
    },
    closeDialog() {
      this.isOpenDialog = false;
      this.$router.go("-1");
    },
  },
  beforeRouteLeave(to, from, next) {
    window.onscroll = () => {};
    document.documentElement.style.overflow = "auto";
    next();
  },
};
</script>
<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0px;
  z-index: 2;
  border-radius: 0 !important;
}
.row {
  border-bottom: solid 1px #f1f1f1;
}
.v-text-field--outlined >>> fieldset {
  border: solid 1px rgba(0, 0, 0, 0.15);
}
.v-dialog {
  overflow-y: hidden;
}
.sku-container {
  overflow-y: auto;
  height: 90vh;
}
</style>
